// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3DBms","footer":"ModalCreateQualiphyProcedure_footer__3l2id","additionData":"ModalCreateQualiphyProcedure_additionData__2y3kt"};